<template>
	<div>
		<div class="on-boarding-step-explanation-text">
			Tools are features you can use anywhere. They are accessible in Ply’s
			<br />
			<div class="display-flex flex-row">
				command bar with a keyboard shortcut.
				<div v-if="commandBarShortcut">&nbsp;Your keyboard shortcut is</div>
			</div>
			<b v-if="commandBarShortcut">{{ commandBarShortcut }} </b>
		</div>

		<div class="display-flex flex-row flex-align-center mt-2">
			<AnemicButton @click="editShortcut" tile class="edit-button"> {{ commandBarShortcut ? 'Edit' : 'Set your' }} shortcut </AnemicButton>
			<AnemicButton tile @click="markAsComplete" v-if="!isCompleted && commandBarShortcut" class="on-boarding-step-finish-step-button ml-2">
				Confirm
			</AnemicButton>
		</div>
	</div>
</template>

<script>
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
export default {
	name: 'OnBoardingGetToKnowToolsEditShortcut',
	props: {
		subStepDetails: { type: Object },
		commandBarShortcut: { type: String },
	},
	components: {},
	computed: {
		isCompleted() {
			return this.subStepDetails.isCompleted;
		},
	},
	methods: {
		markAsComplete() {
			this.$emit('mark-step-as-done', this.subStepDetails);
		},
		editShortcut() {
			AppDialogManagerService.openEditCommandBarShortcutDialog();
		},
	},
	created() {},
	data() {
		return {};
	},
};
</script>

<style scoped lang="scss">
.edit-button {
	height: 30px !important;
	font-size: 14px !important;
	color: #5858ec !important;
	border: 1px solid #5858ec;
	padding: 0px 10px !important;
	border-radius: 11px !important;
	font-weight: normal !important;
	letter-spacing: 0px !important;
	background: white !important;
}
</style>
